import { z } from "zod";

export const DeleteUploadedFileInputSchema = z.object({
    fileId: z.string(),
    requestId: z.string(),
    userName: z.string().nullish(),
});

export type DeleteUploadedFileInput = z.infer<typeof DeleteUploadedFileInputSchema>;